import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { History } from 'history';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { useCallback } from 'react';

import SidebarMenuItem from './SidebarMenuItem';

const SidebarMenuLink = ({ to, icon, title, activePath }: Props) => {
  const { pathname } = useLocation();
  const { push }: History = useHistory();

  const onClick = useCallback(() => {
    push(to);
  }, [to]);

  const matchBase = activePath || to;
  const isActive = pathname === matchBase || pathname.startsWith(`${matchBase}/`);

  return (
    <SidebarMenuItem
      icon={icon}
      title={title}
      onClick={onClick}
      isActive={isActive}
    />
  );
};

interface Props {
  icon: React.ComponentType<SvgIconProps>;
  to: string;
  title: string;
  activePath?: string;
}

export default SidebarMenuLink;
